import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import _flattern from "lodash/flatten";
import {
  Table,
  TableHeader,
  TableBody,
  expandable,
} from "@patternfly/react-table";
import { Text, TextContent, TextVariants } from "@patternfly/react-core";
import DeleteConfirmationModal from "../general/DeleteConfirmationModal";
import PublishConfirmationModal from "../general/PublishConfirmationModal";

export default (props) => {
  const [columns] = useState([
    {
      title: "Name",
      cellFormatters: [expandable],
    },
    { title: "Acronyms, Short Names, Key Components" },
    { title: "Product" },
    { title: "Link" },
    "",
    "",
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [productSuiteToDelete, setProductSuiteToDelete] = useState({});
  const [isPublishModalOpen, setIsPublishModalOpen] = useState(false);
  const [productSuiteToPublish, setProductSuiteToPublish] = useState({});

  function handleModalToggle() {
    setIsModalOpen(!isModalOpen);
  }
  function handlePublishModalToggle() {
    setIsPublishModalOpen(!isPublishModalOpen);
  }

  const productSuiteToRow = useCallback((productSuite, index) => {
    return [
      {
        isOpen: false,
        cells: [
          productSuite.name,
          productSuite.acronyms,
          productSuite.products.length,
          productSuite.link,
          productSuite.is_draft && {
            title: (
              <Text
                component={TextVariants.a}
                onClick={() => onClickTogglePulish(productSuite)}
              >
                Publish
              </Text>
            ),
            props: { component: "th" },
          },
          {
            title: (
              <Link to={`/product/suite/${productSuite.id}/edit`}>Edit</Link>
            ),
            props: { component: "th" },
          },
        ],
      },
      {
        parent: index * 2,
        cells: [renderProductList(productSuite.products, index)],
      },
    ];
  }, []);

  const renderRows = useCallback(() => {
    let renderedRows = [];
    props.productSuites.forEach((productSuite, index) => {
      renderedRows.push(productSuiteToRow(productSuite, index));
    });

    return _flattern(renderedRows);
  }, [props, productSuiteToRow]);

  const [rows, setRows] = useState(renderRows);

  useEffect(() => {
    // if props.activities changed, re-build the rows
    setRows(renderRows);
  }, [props, renderRows]);

  function onClickTogglePulish(productSuite) {
    setProductSuiteToPublish(productSuite);
    setIsPublishModalOpen(true);
  }

  function renderProductList(products, suiteIndex) {
    return (
      <React.Fragment>
        <TextContent>
          {products.map((product) => {
            return (
              <Text
                key={`product-suite-${suiteIndex}-${product.name}`}
                component={TextVariants.p}
              >
                <a
                  href={product.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {product.name}
                </a>
              </Text>
            );
          })}
        </TextContent>
      </React.Fragment>
    );
  }

  function actionResolver(rowData, { rowIndex }) {
    if (!("parent" in rowData)) {
      let title =
        props.productSuites[rowIndex / 2] &&
        props.productSuites[rowIndex / 2].is_draft
          ? "Publish this suite"
          : "Draft this suite";
      return [
        {
          title,
          onClick: (event, rowId, rowData, extra) => {
            // the productSuite's index is doubled to rows as there are collapsed row for each sutie
            // so here we need to divide the rowId by 2 to get the actual index
            onClickTogglePulish(props.productSuites[rowIndex / 2]);
          },
        },
        {
          isSeparator: true,
        },
        {
          title: "Remove Suite",
          onClick: (event, rowId, rowData, extra) => {
            // the productSuite's index is doubled to rows as there are collapsed row for each sutie
            // so here we need to divide the rowId by 2 to get the actual index
            setProductSuiteToDelete(props.productSuites[rowId / 2]);
            setIsModalOpen(true);
          },
        },
      ];
    } else {
      return null;
    }
  }

  function onCollapse(event, rowKey, isOpen) {
    /**
     * Please do not use rowKey as row index for more complex tables.
     * Rather use some kind of identifier like ID passed with each row.
     */

    let newRows = rows.map((row, index) => {
      return index === rowKey ? { ...row, isOpen: isOpen } : row;
    });
    setRows(newRows);
  }

  return (
    <>
      <Table
        aria-label="product-suite"
        onCollapse={onCollapse}
        rows={rows}
        cells={columns}
        actionResolver={actionResolver}
      >
        <TableHeader />
        <TableBody />
      </Table>
      <DeleteConfirmationModal
        name={`${productSuiteToDelete.name}`}
        type={"product suite"}
        productSuiteId={productSuiteToDelete.id}
        isModalOpen={isModalOpen}
        handleModalToggle={handleModalToggle}
      />
      <PublishConfirmationModal
        productSuite={productSuiteToPublish}
        type={"product suite"}
        isModalOpen={isPublishModalOpen}
        handleModalToggle={handlePublishModalToggle}
      />
    </>
  );
};
